/// <reference path="../_references.ts"/>

module App.Customer {
	angular
		.module('customer', [
			'helpers.capitalize',
			'helpers.validations',
			'helpers.states',
			'helpers.phone',
			'helpers.googlePlace',
			'field.dispatch',
		])
		.factory('CustomerService', CustomerService.factory())
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.home.customer', {
					url : '/customer',
					data: {
						title: 'Customer Search',
					},
					views: {
						'content@': {
							controller : 'CustomerSearchController',
							controllerAs: 'customers',
							templateUrl : 'html/customer/customer-search.html',
						},
					},
				})
				.state('zipSolutions.home.customer.create', {
					url: '/create',
					data: {
						title: 'Customer Create',
					},
					views: {
						'content@': {
							controller: 'CustomerCreateController',
							controllerAs: 'customer',
							templateUrl: 'html/customer/customer-create.html',
						},
					},
				})
				.state('zipSolutions.home.service-request', {
					url: '/service-request',
					data: {
						title: 'Service Request Create',
					},
					views: {
						'content@': {
							controller: 'CustomerServiceRequestController',
							controllerAs: 'ctrl',
							templateUrl: 'html/customer/service-request.html',
						},
					},
				});
		}])
		.factory('SelectedCustomer', SelectedCustomer.Factory())
		.controller('CustomerSearchController', CustomerSearchController)
		.controller('CustomerCreateController', CustomerCreateController)
		.controller('CustomerServiceRequestController', CustomerServiceRequestController);
}